import * as React from 'react';
import { Paper, TableContainer, Table, TableHead, TableBody, TableRow, Grid } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { StyledTableCell, StyledTableRow } from '../ui/tableStyles';
import { PlayerRankings } from "../../api/api";
export const PlayersList = props => {
    if (props.isLoading) {
        return (React.createElement(Grid, { container: true, justify: "center" },
            React.createElement(Skeleton, { variant: "rect", width: "100%", height: 30, animation: "wave" }),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement(Skeleton, { variant: "rect", width: "100%", height: 150, animation: "wave" })));
    }
    if (!props.players) {
        return null;
    }
    /*if (props.players.length === 0) {
        return <div>Fandt ingen resultater der matchede dine søgekriterier</div>
    }*/
    const players = Object.assign([], props.players);
    players.unshift(new PlayerRankings({
        playerID: -1,
        name: 'Ukendt spiller',
        playerNumber: '',
        gender: ''
    }));
    players.unshift(new PlayerRankings({
        playerID: -2,
        name: 'Ikke fremmødt',
        playerNumber: '',
        gender: ''
    }));
    const handleClick = (player) => {
        props.selectedPlayer(player);
    };
    return (React.createElement(TableContainer, { component: Paper },
        React.createElement(Table, { "aria-label": "customized table" },
            React.createElement(TableHead, null,
                React.createElement(TableRow, null,
                    React.createElement(StyledTableCell, null, "Spillernummer"),
                    React.createElement(StyledTableCell, { align: "right" }, "Spillernavn"),
                    React.createElement(StyledTableCell, { align: "right" }, "Single points"),
                    React.createElement(StyledTableCell, { align: "right" }, "Double points"),
                    React.createElement(StyledTableCell, { align: "right" }, "Mixed points"))),
            React.createElement(TableBody, null, players.map((player) => (React.createElement(StyledTableRow, { key: player.playerID, onClick: () => handleClick(player), hover: true },
                React.createElement(StyledTableCell, { component: "th", scope: "row" }, player.playerNumber),
                React.createElement(StyledTableCell, { align: "right" }, player.name),
                React.createElement(StyledTableCell, { align: "right" }, player.singlePoints),
                React.createElement(StyledTableCell, { align: "right" }, player.doublePoints),
                React.createElement(StyledTableCell, { align: "right" }, player.mixPoints))))))));
};
